<form
  [formGroup]="benForm"
  (ngSubmit)="submitForm()"
  class="tab-form"
  autocomplete="off"
  novalidate
>
  <div class="form-80">
    <h1 class="blue margin">{{ title }}</h1>
    <p class="lead rocal" style="margin-bottom: 0px">{{ subtitle }}</p>

    <!-- Panel 1: Beneficiary Info -->
    <ng-template #beneficiaryInfo let-i="index">
      <div *ngIf="getBensFormGroup(i)">
        <div class="line-section"></div>

        <div class="row half" *ngIf="!beneficiaries[i].personalDone">
          <app-input
            [formGroup]="getBensFormGroup(i)"
            controlName="Category"
            inputType="select"
            [selectFunction]="onBenTypeChange.bind(this)"
            [selectParam]="i"
            [ArrayItems]="BeneficiaryOptions"
            label="{{ benTypeLabel }}"
            hint="{{ benTypeHint }}"
            [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() ==='individual' ">
          <div class="row-alt">
            <div class="row-mini">
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="Title"
                label="{{ titleLabel }}"
                hint="{{ titleHint }}"
                inputType="auto-complete"
                [loadingOptions]="loadingTitles"
                [ArrayItems]="TitleOptions"
                required="false"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>

              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="FirstName"
                label="{{ fNameLabel }}"
                hint="{{ fNameHint }}"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
            </div>

            <div class="row-mini">
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="MiddleName"
                label="{{ mNameLabel }}"
                hint="{{ mNameHint }}"
                required="false"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="LastName"
                label="{{ surnameLabel }}"
                hint="{{ surnameHint }}"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
            </div>
          </div>

          <div class="row">
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="Phone"
              class="grid-item"
              label="{{ phoneLabel }}"
              inputType="phone"
              required="false"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="Email"
              class="grid-item"
              label="{{ emailLabel }}"
              hint="{{ emailLabel }}"
              required="false"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="Gender"
              label="{{ genderLabel }}"
              hint="{{ genderHint }}"
              inputType="select"
              [ArrayItems]="GenderOptions"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="DOB"
              class="grid-item"
              label="{{ dobLabel }}"
              hint="{{ dobHint }}"
              [minDate]="minDate"
              [maxDate]="maxDate"
              inputType="date"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution'">
          <div class="row">
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="InstitutionName"
              class="grid-item"
              label="{{ institutionNameLabel }}"
              hint="{{ institutionNameHint }}"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="BusinessNature"
              label="{{ businessNatureLabel }}"
              hint="{{ businessNatureHint }}"
              inputType="select"
              [ArrayItems]="BusinessNatureOptions"
              [loadingOptions]="loadingBizNature"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="OrgRegNum"
              class="grid-item"
              label="{{ orgRegNumLabel }}"
              hint="{{ orgRegNumHint }}"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="KraPin"
              class="grid-item"
              label="{{ kraPinLabel }}"
              hint="{{ kraHint }}"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div class="row" [ngClass]="{half: (!arrayContainsValue(getBensFormGroup(i).get('TrustPurpose')?.value, 'Other') && getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual')}">
          <app-input *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution' "
            [formGroup]="getBensFormGroup(i)"
            controlName="OrgAddress"
            class="grid-item"
            label="{{ orgAddressLabel }}"
            hint="{{ orgAddressHint }}"
            [validationMessages]="validationMessages"
            [formErrors]="formErrors"
          ></app-input>
          
          <app-input
            [formGroup]="getBensFormGroup(i)"
            controlName="TrustPurpose"
            label="{{ purposeLabel }}"
            hint="{{ purposeHint }}"
            inputType="multi-select"
            [ArrayItems]="TrustPurposeOptions"
            [subtext]="purposeSubtext"
            [loadingOptions]="loadingTrustPurposeOptions"
            [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>

          <app-input
            [formGroup]="getBensFormGroup(i)"
            controlName="OtherPurpose"
            *ngIf="arrayContainsValue(getBensFormGroup(i).get('TrustPurpose')?.value, 'Other') && getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual'"
            label="{{ otherPurposeLabel }}"
            hint="{{ otherPurposeHint }}"
            [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half"
          *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution' && arrayContainsValue(getBensFormGroup(i).get('TrustPurpose')?.value, 'Other')">
          <app-input
            [formGroup]="getBensFormGroup(i)"
            controlName="OtherPurpose"
            *ngIf="arrayContainsValue(getBensFormGroup(i).get('TrustPurpose')?.value, 'Other')"
            label="{{ otherPurposeLabel }}"
            hint="{{ otherPurposeHint }}"
            [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2 (Institutions): Contact Info -->
    <ng-template #contactInfo let-i="index">
      <div *ngIf="getBens() && getBensFormGroup(i)">
        <div class="line-section"></div>

        <div formArrayName="ContactPersons" *ngIf="getContacts(i).controls">
          <div *ngFor="let contact of getContacts(i).controls; let j = index" [formGroupName]="j" style="position: relative">
            <div *ngIf="getContactsFormGroup(i, j)">
              <div style="height: 50px" *ngIf="j > 1"></div>

              <div class="line-2" *ngIf="j > 0"></div>
              
              <p style="font-weight: 600; font-size: 1.2em">
                  {{ "Contact Person " + (j + 1) }}
              </p>
              

              <div class="row-alt">
                  <div class="row-mini">
                  <app-input
                      [formGroup]="getContactsFormGroup(i, j)"
                      controlName="Title"
                      label="{{ titleLabel }}"
                      hint="{{ titleHint }}"
                      inputType="auto-complete"
                      [loadingOptions]="loadingTitles"
                      [ArrayItems]="TitleOptions"
                      required="false"
                      [validationMessages]="validationMessages"
                      [formErrors]="formErrors"
                  >
                  </app-input>

                  <app-input
                      [formGroup]="getContactsFormGroup(i, j)"
                      controlName="FirstName"
                      label="{{ fNameLabel }}"
                      hint="{{ fNameHint }}"
                      [validationMessages]="validationMessages"
                      [formErrors]="formErrors"
                  ></app-input>
                  </div>

                  <div class="row-mini">
                  <app-input
                      [formGroup]="getContactsFormGroup(i, j)"
                      controlName="MiddleName"
                      label="{{ mNameLabel }}"
                      hint="{{ mNameHint }}"
                      required="false"
                      [validationMessages]="validationMessages"
                      [formErrors]="formErrors"
                  ></app-input>
                  <app-input
                      [formGroup]="getContactsFormGroup(i, j)"
                      controlName="LastName"
                      label="{{ surnameLabel }}"
                      hint="{{ surnameHint }}"
                      [validationMessages]="validationMessages"
                      [formErrors]="formErrors"
                  ></app-input>
                  </div>
              </div>

              <div class="row">
                  <app-input
                    [formGroup]="getContactsFormGroup(i, j)"
                    controlName="Phone"
                    class="grid-item"
                    label="{{ phoneLabel }}"
                    inputType="phone"
                    [validationMessages]="validationMessages"
                    [formErrors]="formErrors">
                  </app-input>
                  <app-input
                    [formGroup]="getContactsFormGroup(i, j)"
                    controlName="Email"
                    class="grid-item"
                    label="{{ emailLabel }}"
                    hint="{{ emailLabel }}"
                    [validationMessages]="validationMessages"
                    [formErrors]="formErrors">
                  </app-input>
              </div>

              <div class="remove-button" *ngIf="j > 0">
                  <button
                  mat-stroked-button
                  type="button"
                  (click)="removeContact(i, j)"
                  >
                  <div style="display: flex; flex: 1; align-items: center">
                      <span class="button-text">
                      <u>{{ removeContactText }}</u>
                      </span>
                  </div>
                  </button>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTTON Add Contact person -->
        <div
          class="blueStroke row"
          [ngClass]="{ 'min-55': getContacts(i) && getContacts(i).length > 1 }"
        >
          <button
            mat-stroked-button
            [disabled]="!benForm.valid"
            type="button"
            (click)="addNewContact(i)"
          >
            <span class="button-text">
              {{ "+ Add Contact Person" }}
            </span>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Panel 3: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getBensFormGroup(i)">
        <div class="line-section"></div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual' ">
          <div *ngIf="getBensFormGroup(i).get('DOB')?.value !== '' && getDateDifference(getBensFormGroup(i).get('DOB')?.value) === true">
            <div class="row">
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="IDNoImage"
                [fileFunction]="updateIDObject.bind(this, i)"
                [existingFileName]="beneficiaries[i]?.IDNoImage?.name != '' ? beneficiaries[i]?.IDNoImage?.name : '' "
                class="grid-item"
                label="{{ idFileLabel }}"
                hint="{{ idHint }}"
                inputType="file"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
              <app-input
                [formGroup]="getBensFormGroup(i)"
                class="grid-item"
                controlName="KraPinImage"
                label="{{ kraFileLabel }}"
                inputType="file"
                [required]="region == 1 ? 'false' : 'true' "
                [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                [fileFunction]="updateKraObject.bind(this, i)"
                [existingFileName]="beneficiaries[i]?.KraPinImage?.name != '' ? beneficiaries[i]?.KraPinImage?.name : '' "
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
            </div>

            <div class="row">
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="IDNo"
                label="{{ idLabel }}"
                hint="{{ idHint }}"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="KraPin"
                label="{{ kraPinLabel }}"
                hint="{{ kraHint }}"
                [required]="region == 1 ? 'false' : 'true' "
                [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
            </div>
          </div>

          <div *ngIf="getBensFormGroup(i).get('DOB')?.value !== '' && getDateDifference(getBensFormGroup(i).get('DOB')?.value) === false">
            <div class="row">
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="BirthCertImage"
                [fileFunction]="updateBirthCertObject.bind(this, i)"
                [existingFileName]="beneficiaries[i]?.BirthCertImage?.name != '' ? beneficiaries[i]?.BirthCertImage?.name : '' "
                class="grid-item"
                label="{{ birthCertLabel }}"
                inputType="file"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
              <app-input
                [formGroup]="getBensFormGroup(i)"
                controlName="BirthCertNo"
                label="Birth Certificate Number"
                hint="Birth certificate number"
                [validationMessages]="validationMessages"
                [formErrors]="formErrors"
              ></app-input>
            </div>
          </div>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution' ">
          <div class="row">
            <app-input
              [formGroup]="getBensFormGroup(i)"
              controlName="RegCertImage"
              class="grid-item"
              label="{{ regCertFileLabel }}"
              inputType="file"
              [fileFunction]="updateRegCertObject.bind(this, i)"
              [existingFileName]="beneficiaries[i]?.RegCertImage?.name != '' ? beneficiaries[i]?.RegCertImage?.name : '' "
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"
            ></app-input>
            <app-input
              [formGroup]="getBensFormGroup(i)"
              class="grid-item"
              controlName="KraPinImage"
              [fileFunction]="updateKraObject.bind(this, i)"
              [existingFileName]="beneficiaries[i]?.KraPinImage?.name != '' ? beneficiaries[i]?.KraPinImage?.name : '' "
              label="{{ kraFileLabel }}"
              inputType="file"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"
            ></app-input>
          </div>
        </div>
      </div>
    </ng-template>

    <div formArrayName="beneficiaries">
      <div *ngFor="let ben of getBens().controls; let i = index" [formGroupName]="i" style="position: relative" >
        <div style="height: 80px" *ngIf="beneficiaries.length > 0 && i > 0"></div>

        <div style="display: flex; justify-content: space-between; align-items: center;">
          <p style="font-weight: 600; font-size: 1.3em" class="blue margin">
            {{ "Beneficiary " + (i + 1) +(beneficiaries[i].PercShare && beneficiaries[i].PercShare !== 0 && beneficiaries[i].PercShare !== '0' ? ' (' + beneficiaries[i].PercShare + '%)' : '') }}
          </p>
          <button class="update" mat-stroked-button type="button" *ngIf="areSharesAwarded() == true && i === 0"
            [disabled]="loading || loadingRemove" 
            (click)="showSharesPopup.set(true)" >
              <span class="button-text">
                {{ 'Re-assign Shares' }}
              </span>
          </button>
        </div>
        
        

        <!-- Accordion -->
        <app-section [panels]="benPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>
        <!-- ++++++++++++++++++++++++++++ -->

        <div class="action-buttons">
          <button mat-stroked-button type="button" class="remove" (click)="removeBen(i)" *ngIf="getBens().length > 1">
              <div style="display: flex; flex: 1; align-items: center;">
                <span class="button-text">
                  <u>{{
                    getBens().controls.length - 1 === i
                    ? removeButtonText
                    : removeBenText
                  }}</u>
                </span>
                <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                  <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                  </mat-progress-spinner>
                </span>
              </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getBens() && !confirmFormMatchesRecord(i)"
              [disabled]="loading || loadingRemove" 
              (click)="updateRecord(i)" >
              <span class="button-text">
                {{ 'Update Beneficiary ' +(i+1) }}
              </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Ben -->
    <div
      class="benStroke row"
      [ngClass]="{
        'min-55':
          getBens().length > 1 ||
          (beneficiaries[beneficiaries.length - 1].done &&
            finalRemainingShares > 0)
      }"
    >
      <button
        mat-stroked-button
        *ngIf="beneficiaries[beneficiaries.length - 1]?.done && benForm.valid"
        [disabled]="!beneficiaries[beneficiaries.length - 1].done || !benForm.valid || remainingShares === 0"
        type="button"
        (click)="addNewBen()"
      >
        <span class="button-text">
          {{
            remainingShares === 0
              ? "Maximum shares allocated"
              : "+ Add New Beneficiary"
          }}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom
    style="width: 100%"
    [formValid]="
      benForm.valid || beneficiaries[beneficiaries.length - 1].done === true
    "
    [showContinue]="benForm.valid ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)"
    [text]="
      loading
        ? loadingText
        : beneficiaries[beneficiaries.length - 1].done
        ? (areSharesAwarded() ? 'Next' : 'Assign Shares')
        : beneficiaries[beneficiaries.length - 1].contactsDone
        ? 'Upload Documents'
        : beneficiaries[beneficiaries.length - 1].personalDone
        ? 'Update Details'
        : 'Save Details'
    "
    [buttonClickHandler]="submitForm.bind(this)"
  >
  </app-form-bottom>
</form>

<ng-container *ngIf="showSharesPopup()">
  <app-shares 
    [showSharesPopup]="showSharesPopup" 
    [areSharesAwarded]="areSharesAwarded">
  </app-shares>
</ng-container>
